module.exports = __webpack_public_path__ + "static/media/12-1.5beeda2a.png";